import styled from '@emotion/styled';
import { ButtonPrimary } from './layout/StyledComponents';
import piza from '../images/1-homepage/homepage-6-pisa.png';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { getImage, IGatsbyImageData, GatsbyImage } from 'gatsby-plugin-image';

export const OfficeTourStyled = styled.section`
    color: ${({ theme }) => theme.colors.yellow3};
    margin-bottom: 80px;
    padding: 0 !important;
    h2 {
        text-align: center;
        margin-bottom: 24px;
    }
    button {
        width: 100%;
    }
    .image-container {
        display: flex;
        gap: 16px;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 24px;

        > .gatsby-image-wrapper {
            border-radius: 15px;
        }
    }
    @media ${({ theme }) => theme.device.tablet} {
        .image-container {
            margin-bottom: 48px;
        }
        h2 {
            margin-bottom: 32px;
        }
    }
    @media ${({ theme }) => theme.device.laptop} {
        background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)),
            url(${piza});
        background-size: 60%;
        background-repeat: no-repeat;
        background-position: 500px -10px;
        margin-bottom: 80px;

        button {
            width: 211px;
            margin: 0 auto;
        }
    }
`;

interface Props {
    homepage?: boolean;
}

export const OfficeTour: React.FC<Props> = ({ homepage }) => {
    type DataType = {
        allFile: {
            nodes: {
                img: IGatsbyImageData;
                id: string;
            }[];
        };
    };

    const {
        allFile: { nodes },
    }: DataType = useStaticQuery(graphql`
        query officeTourImages {
            allFile(
                filter: { relativeDirectory: { eq: "office-tour-images" } }
                sort: { name: ASC }
            ) {
                nodes {
                    img: childImageSharp {
                        gatsbyImageData(width: 342, height: 300, quality: 80)
                        id
                    }
                }
            }
        }
    `);

    console.log(nodes.length);

    const images = nodes.map(node => ({
        img: getImage(node.img) as IGatsbyImageData,
        id: node.id,
    }));
    return (
        <OfficeTourStyled className="large-container">
            {homepage && <h2 className="header-2">Our Outstanding Staff</h2>}
            <div className="image-container">
                {images.map(node => (
                    <GatsbyImage key={node.id} image={node.img} alt="kidz dental care office" />
                ))}
            </div>
            {homepage && (
                <Link to="/for-parents/patient-reviews/">
                    <ButtonPrimary color="blue">Read Our Reviews</ButtonPrimary>
                </Link>
            )}
        </OfficeTourStyled>
    );
};
